export const findIndexOfItemToRemove = ({ items, id }) => items.map(x => x.id).indexOf(id);
